export default "__VITE_ASSET__754p$BDT__"